// extracted by mini-css-extract-plugin
export default {"nsa_section_tabs_parent":"NSASectionTabs_nsa_section_tabs_parent__U8rOp","nsa_section_tabs_item":"NSASectionTabs_nsa_section_tabs_item__y-xzv"};